import { Injectable } from '@angular/core';
import { BaseReactiveStore } from '../shared/base-reactive-store';

import { Observable } from "rxjs";
import { ListResultDto } from '../shared/crud/models/ListResultDto';
import { IdentityRoleDto } from '../role-data/models/RoleDtos';
import { HttpClient } from '@angular/common/http';
import { EnvironmentService } from '../core/environment/environment.service';

export class UserRoleAssignableState {
  items: Array<IdentityRoleDto> = new Array<IdentityRoleDto>()
}

@Injectable({
  providedIn: null
})
export class UserRoleAssignableService extends BaseReactiveStore<UserRoleAssignableState> {

  assignableRoles$: Observable<Array<IdentityRoleDto>>
    = this.select(state => state.items);

  constructor(private http: HttpClient, private environmentService: EnvironmentService) {
    super(new UserRoleAssignableState());
    this.reloadAssignableRoles();
  }

  reloadAssignableRoles() {
    this.http.get<ListResultDto<IdentityRoleDto>>(this.environmentService.getConfig().api.baseUrl + '/api/identity/users/assignable-roles')
      .subscribe((val) => {
        const stack: IdentityRoleDto[] = [];
        val.items.forEach(value => {
          stack.push(value);
        });
        this.setState({ items: stack });
      });
  }

}
